import React from "react";
import { useSAPublicConfig } from '../../hooks/useSAConfig';

import newLogoTrademark from "../../images/reactiveImages/Botmark_Logo_Large_Trademark.jpg";
import layoutSpecialties from "../../images/reactiveImages/Layout Specialty Logo_new.JPG";
import solutionTitle from "../../images/reactiveImages/Solution title.jpg";
import titleLine from "../../images/reactiveImages/Botmark title line_new.jpg";

import img1vq from "../../images/reactiveImages/IMG_3705_lq.JPG";
import img9vq from "../../images/reactiveImages/IMG_3593.JPG";
import img2vq from "../../images/reactiveImages/IMG_3007_lq.jpg";
import img3vq from "../../images/reactiveImages/IMG_2635_lq.JPG";
import img4vq from "../../images/reactiveImages/IMG_4220_lq.JPG";
import img5vq from "../../images/reactiveImages/IMG_3956_new_vertical_lq.JPG";
import img6vq from "../../images/reactiveImages/IMG_4125_new_vertical_lq.JPG";
import img11vq from "../../images/reactiveImages/IMG_3791_new_vertical_lq.JPG";

import img9 from "../../images/reactiveImages/IMG_3593_new_small.JPG";

import img1q from "../../images/reactiveImages/IMG_3705_new_small_lq.JPG";
import img2q from "../../images/reactiveImages/IMG_3007_new_small_lq.JPG";
import img3q from "../../images/reactiveImages/IMG_2635_new_small_lq.JPG";
import img4q from "../../images/reactiveImages/IMG_4220_new_small_lq.JPG";
import img5q from "../../images/reactiveImages/IMG_3956_new_small_lq.JPG";
import img6q from "../../images/reactiveImages/IMG_4125_new_small_lq.JPG";
import img7q from "../../images/reactiveImages/IMG_4128_new_small_lq.JPG";
import img11q from "../../images/reactiveImages/IMG_3791_new_small_horizontal_lq.JPG";

import "../auth/Login.css";

function HomePage() {
    const opts = {
        height: '425px',
        width: '100%',
    };

    const { data: saConfigData } = useSAPublicConfig();
    const publicAnn = saConfigData?.configValue ?? 'N/A';

    return (
        <div style={{
            backgroundColor: 'black',
            height:"100%"
        }}>
            <div className="large" style={{ display: 'flex', justifyContent:'center', height:"100%" }}>
                <div
                    style={{
                        height: '100%',
                        maxWidth:'90vw',
                        minWidth:0,
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        backgroundColor: 'black',
                    }}
                >
                    {/* Top Header Section */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            minWidth:0,
                            height: 'auto',
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Left Logo */}
                        <div style={{ maxWidth: '15%', height: 'auto', minWidth:0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <a
                                href="https://www.layoutspecialties.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="layoutSpecialtiesLogoLink"
                                style={{ maxWidth: '100%', height: 'auto' }}
                                title="Visit Layout Specialties"
                            >
                                <img
                                    src={layoutSpecialties}
                                    alt="Layout Specialties"
                                    style={{ maxWidth: '100%', maxHeight: 'auto', minWidth:0, objectFit: 'contain' }}
                                />
                            </a>
                        </div>

                        {/* Center Logos */}
                        <div style={{ maxWidth: '65%', height: 'auto', minWidth:0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <img
                                src={newLogoTrademark}
                                alt="Logo"
                                style={{ maxWidth: '100%', height:'auto', minWidth:0, objectFit: 'contain' }}
                            />
                            <img
                                src={titleLine}
                                alt="Title Line"
                                style={{ maxWidth: '100%', height: 'auto', minWidth:0, objectFit: 'contain' }}
                            />
                        </div>

                        {/* Right Logo */}
                        <div style={{ maxWidth: '15%', height: 'auto', minWidth:0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img
                                src={solutionTitle}
                                alt="Right"
                                style={{ maxWidth: '100%', maxHeight: 'auto', minWidth:0, objectFit: 'contain' }}
                            />
                        </div>
                    </div>

                    {/* Middle Content (Images Grid + Announcement) */}
                    <div
                        style={{
                            height: '-webkit-fill-available',
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: '1%',
                            alignItems:'center',
                            minWidth:0
                        }}
                    >
                        <div style={{
                            paddingBottom: '1%',
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            minWidth:0
                        }}>
                            {/* Images Grid - Auto-resizing and wrapping */}
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    height: 'auto',
                                    maxWidth:'100%',
                                    minWidth:0
                                }}
                            >
                                {[img1q, img9, img4q].map((src, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            margin: 5,
                                            width: 'fit-content',
                                            minWidth:0,
                                        }}
                                        className="imgBox"
                                    >
                                        <input type="checkbox" id={src}/>
                                        <label className="imgLabel" htmlFor={src}>
                                            <img
                                                src={src}
                                                alt={`img-${index}`}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: 'auto',
                                                    objectFit: 'contain',
                                                    minWidth:0,
                                                }}
                                            />
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    minWidth:0
                                }}
                            >
                                {[img5q, img7q, img6q, img11q].map((src, index) => (
                                    <div
                                        key={src}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            margin: 5,
                                            minWidth:0
                                        }}
                                        className="imgBox"
                                    >
                                        <input type="checkbox" id={src}/>
                                        <label className="imgLabel" htmlFor={src}>
                                            <img
                                                src={src}
                                                alt={`img-${index}`}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: 'auto',
                                                    objectFit: 'contain',
                                                    minWidth:0,
                                                }}
                                            />
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Announcement Section */}
                        <div
                            style={{
                                backgroundColor: 'gray',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 'x-large',
                                textAlign: 'center',
                                width:'-webkit-fill-available',
                                minWidth:0
                            }}
                        >
                            <span><b>{publicAnn}</b></span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="medium" style={{ display: 'none' }}>
                <div
                    style={{
                        width: '100vw',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        backgroundColor: 'black',
                    }}
                >
                    {/* Top Header Section */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            padding: '1%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Left Logo */}
                        <div style={{ width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <a
                                href="https://www.layoutspecialties.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="layoutSpecialtiesLogoLink"
                                style={{ maxWidth: '100%', maxHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                title="Visit Layout Specialties"
                            >
                                <img
                                    src={layoutSpecialties}
                                    alt="Layout Specialties"
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            </a>
                        </div>

                        {/* Center Logos */}
                        <div style={{ width: '70%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <img
                                src={newLogoTrademark}
                                alt="Logo"
                                style={{ width: '100%', objectFit: 'contain' }}
                            />
                        </div>

                        {/* Right Logo */}
                        <div style={{ width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img
                                src={solutionTitle}
                                alt="Right"
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                            />
                        </div>
                    </div>

                    {/* Title Line Row */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingLeft: 10,
                            paddingRight: 10
                        }}
                    >
                        <img
                            src={titleLine}
                            alt="Title Line"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>

                    {/* Main Content Section */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            boxSizing: 'border-box',
                            maxHeight: '83%'
                        }}
                    >
                        {/* Image Grid */}
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                paddingRight: '5%',
                                paddingLeft: '5%',
                                paddingTop: '1%',
                                paddingBottom: '1%',
                                boxSizing: 'border-box',
                            }}
                        >
                            {[img1q, img9, img2q, img3q, img4q, img5q, img6q, img11q].map((src, index) => (
                                <div
                                    key={index}
                                    style={{
                                        width: '42%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        paddingTop: '1%',
                                        paddingBottom: '1%',
                                        minWidth:0,
                                        minHeight:0
                                    }}
                                    className="imgBox"
                                >
                                    <input type="checkbox" id={index}/>
                                    <label className="imgLabel" htmlFor={index}>
                                        <img
                                            src={src}
                                            alt={`img-${index}`}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain',
                                                minWidth:0,
                                                minHeight:0,
                                            }}
                                        />
                                    </label>
                                </div>
                            ))}
                        </div>

                        {/* Announcement Section */}
                        <div
                            style={{
                                backgroundColor: 'gray',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 'x-large',
                                textAlign: 'center',
                                padding: '0 1vw',
                                boxSizing: 'border-box',
                            }}
                        >
                            <span><b>{publicAnn}</b></span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="small" style={{ display: 'none' }}>
                <div
                    style={{
                        width: '100vw',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        backgroundColor: 'black',
                        overflow: 'auto',
                    }}
                >
                    {/* Top Header Section */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Left Logo */}
                        <div style={{ width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <a
                                href="https://www.layoutspecialties.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="layoutSpecialtiesLogoLink"
                                style={{ maxWidth: '100%', maxHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                title="Visit Layout Specialties"
                            >
                                <img
                                    src={layoutSpecialties}
                                    alt="Layout Specialties"
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            </a>
                        </div>

                        {/* Center Logos */}
                        <div style={{ width: '70%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <img
                                src={newLogoTrademark}
                                alt="Logo"
                                style={{ width: '100%', objectFit: 'contain' }}
                            />
                        </div>

                        {/* Right Logo */}
                        <div style={{ width: '15%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img
                                src={solutionTitle}
                                alt="Right"
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                            />
                        </div>
                    </div>

                    {/* Title Line Row */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingLeft: 10,
                            paddingRight: 10
                        }}
                    >
                        <img
                            src={titleLine}
                            alt="Title Line"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>

                    {/* Main Content Section */}
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            boxSizing: 'border-box',
                            maxHeight: '83%'
                        }}
                    >
                        {/* Image Grid */}
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                height: '88%',
                                padding: '1%',
                                paddingRight: '3%',
                                paddingLeft: '3%',
                                boxSizing: 'border-box',
                            }}
                        >
                            {[img1vq, img9vq, img2vq, img3vq, img4vq, img5vq, img6vq, img11vq].map((src, index) => (
                                <div
                                    key={index}
                                    style={{
                                        width: '45%',
                                        height: '24%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                    className="imgBox"
                                >
                                    <input type="checkbox" id={index}/>
                                    <label className="imgLabel" htmlFor={index}>
                                        <img
                                            src={src}
                                            alt={`img-${index}`}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                minHeight:0,
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </label>
                                </div>
                            ))}
                        </div>

                        {/* Announcement Section */}
                        <div
                            style={{
                                backgroundColor: 'gray',
                                color: 'white',
                                height: '10%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 'large',
                                textAlign: 'center',
                                padding: '0 1vw',
                                boxSizing: 'border-box',
                            }}
                        >
                            <span><b>{publicAnn}</b></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage;